import React, { Fragment } from 'react';

export const parseUnderlines = (string) => {
  // Render "__string__" as underlined text in database responses
  const arr = string.split('__');
  if (/^__/.test(string)) { // if string begins with an underline
    return arr.map((part, i) => (
      // underline odd sections
      i % 2
        ? <Fragment key={part}>{part}</Fragment>
        : <u key={part}>{part}</u>
    ));
  }
  return arr.map((part, i) => (
    // otherwise underline even sections
    i % 2
      ? <u key={part}>{part}</u>
      : <Fragment key={part}>{part}</Fragment>
  ));
};

export default { parseUnderlines };



// WEBPACK FOOTER //
// ./src/utils/parseUnderlines.js